import { Link } from "react-router-dom";
import logoImage from "@/assets/logo.png";

interface LogoProps {
  variant?: "light" | "dark";
  className?: string;
}

const Logo = ({ variant = "light", className = "" }: LogoProps) => {
  return (
    <Link 
      to="/" 
      className={`block transition-opacity duration-300 hover:opacity-80 ${className}`}
    >
      <img 
        src={logoImage} 
        alt="אמון בזוגיות" 
        className="h-16 md:h-20 lg:h-24 w-auto"
      />
    </Link>
  );
};

export default Logo;
